<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box flex flex-col justify-center items-center text-center">
        <h2 class="font-bold text-2xl text-error">{{ 'shared.file_upload.replace_file' | transloco }}</h2>
        <p class="text-neutral-800 text-base mt-10">{{ 'shared.file_upload.file_exists' | transloco }}</p>
        <p class="text-neutral-800 text-sm mt-5"><span class="font-bold">{{ 'shared.file_upload.following_items' | transloco }}</span><br> {{replaceFileNames}}</p>
        <div class="flex gap-2 w-full justify-between mt-10">
            <div class="w-[45%] h-[50px]">
                <app-custom-button (click)="closeModal(true)" buttonText="{{ 'shared.yes' | transloco }}"
                    backgroundColor="bg-error" textColor="text-black" borderColor="border:bg-error"
                    hoverBackgroundColor="hover:bg-error-1200"></app-custom-button>
            </div>
            <div class="w-[45%] h-[50px]">
                <app-custom-button (click)="closeModal(false)" buttonText="{{ 'shared.no' | transloco }}"
                    backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
            </div>
        </div>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button (click)="closeModal(false)">Close</button>
    </form>
</dialog>